import React, { Component } from 'react';
import {connect} from "react-redux";
import ResponsesComponent from "./responses-component";
import { changePageRequest, loadResponsesRequest } from "./responses-action-creators";
import {setSelectedText, showContextMenu} from "../context-menu/context-menu-action-creators";
import {getSelectedText} from "../context-menu/context-menu-functions";

class ResponsesContainer extends Component {

  componentDidMount() {
    const { loadResponses, reportUrl, whoMounted, filtersLoaded } = this.props;
    whoMounted !== reportUrl && filtersLoaded ? loadResponses({page: 1, whoMounted: reportUrl, clean: true}) : null;
  }

  componentDidUpdate(prevProps) {
    const { loadResponses, reportUrl, whoMounted, filtersLoaded } = this.props;
    whoMounted !== reportUrl && !prevProps.filtersLoaded && filtersLoaded
      ?
      loadResponses({page: 1, whoMounted: reportUrl, clean: true})
      :
      null;
  }

  render() {
    return <ResponsesComponent {...this.props} />
  }
}


const mapStateToProps = state => ({
  filtersLoaded: state.filters.loaded,
  responses: state.responses.responses,
  loading: state.responses.loading,
  page: state.responses.page,
  totalPages: state.responses.totalPages,
  error: state.responses.error,
  whoMounted: state.responses.whoMounted,
  reportUrl: state.report.reportUrl
});

const mapDispatchToProps = dispatch => ({
  loadResponses: ({whoMounted, page, clean}) => dispatch(loadResponsesRequest({page, whoMounted, clean})),
  changePage: ({ page, previous, next }) => dispatch(changePageRequest({ page, previous, next })),
  showContextMenu: ({ top, left }) => dispatch(showContextMenu({ top, left })),
  setSelectedText: () => dispatch(setSelectedText(getSelectedText()))
});


export default connect(mapStateToProps, mapDispatchToProps)(ResponsesContainer)


// WEBPACK FOOTER //
// ./src/modules/responses/responses-container.js